import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Banner from "../../Banner/Banner";
import "./Currentproperties.css";
import parse from "html-react-parser";
import { convertToSlug } from "../../../components/api";
// import ErrorPage from "../../ErrorPage/ErrorPage";

const BASEURL = process.env.REACT_APP_SOMPROP_BASE_URL;

const OverlayPage = () => {
  // Extract the property slug from the URL

  const [menuList, setMenuList] = useState();
  const [allData, setAllData] = useState([]);

  useEffect(() => {
    fetch("https://admin.webappclouds.com/wsmenu/menu_list/200029/17437/")
      .then((response) => response.json())
      .then((data) => {
        setMenuList(data);
      });
  }, []);

  useEffect(() => {
    if (menuList) {
      let promises = menuList.map((item) => {
        return fetch(
          `https://admin.webappclouds.com/wsmenu/sub_menu_list/200029/17437/${item.menu_id}`
        ).then((response) => response.json());
      });
      Promise.all(promises).then((responses) => {
        let combinedJsonArray = responses.reduce(
          (accumulator, currentValue) => accumulator.concat(currentValue),
          []
        );
        setAllData(combinedJsonArray);
      });
    }
  }, [menuList]);

  return (
    <div>
      <Banner />
      {allData ? (
        <Overlay
          property={allData}
          onClose={() => {
            /* define close handler */
            window.history.back();
          }}
        />
      ) : (
        <div>Loading...</div>
      )}
    </div>
  );
};

export default OverlayPage;

const Overlay = ({ property, onClose }) => {
  const navigate = useNavigate();
  const { propertySlug  } = useParams();

  console.log(propertySlug, 'propertySlug')
  
  const [propertyData, setPropertyData] = useState();
 
  useEffect(() => {

     

    const filterData =
      property &&
      property.find(
        (item) => convertToSlug(`${item.sub_menu_title}-${item.sub_menu_id}`) === propertySlug 
      );
  
    if (filterData) {
      setPropertyData(filterData);
    }
  
    // if (filterData === undefined && propertyData === "") {
    //   navigate(BASEURL + "/404-error");
    // }
  }, [property, propertySlug, navigate, propertyData]);

  if (!propertyData)
    return (
      <div className="shimmer-main row" style={{margin:'40px auto', maxWidth:'1100px'}}>
         <div className="shimmer" style={{minHeight:'400px',display:'block',width:'48%',marginRight:'20px'}}>
         </div>
         <div className="shimmer" style={{minHeight:'400px',display:'block',width:'48%',marginRight:'20px'}}>
         </div>
      </div>
    );

  const data = propertyData.sub_menu_externallink && propertyData.sub_menu_externallink.split("~");

  return (
    <div className="container">
      <div className="portfolio-details-section">
        {propertyData ? (
          <div className="row">
            <div className="col-md-6 col-sm-6 col-12">
              <div className="portfolio-details-left">
                <div className="page-back">
                  <button
                    onClick={onClose}
                    // style={{
                    //   background: "none",
                    //   border: "none",
                    //   cursor: "pointer",
                    //   textDecoration: "underline",
                    //   color: "blue",
                    // }}
                  >
                    <span>
                      <img
                        src={`${BASEURL}/images/right_arrow.svg`}
                        width="26"
                        height="13"
                        alt="right arrow icon"
                      />
                    </span>{" "}
                    Back
                  </button>
                </div>
                <h3>{propertyData.sub_menu_title}</h3>
                <h4>{parse(propertyData.sub_menu_description)}</h4>
                <p>{propertyData.address}</p>
                <ul>
                  <li>
                    <button
                    // style={{
                    //   background: "none",
                    //   border: "none",
                    //   cursor: "pointer",
                    //   textDecoration: "underline",
                    //   color: "blue",
                    // }}
                    >
                      <span>
                        <img
                          src={`${BASEURL}/images/flex.svg`}
                          width="24"
                          height="23"
                          alt="flex icon"
                        />
                      </span>{" "}
                      {propertyData.sub_menu_price}
                    </button>
                  </li>
                  <li>
                    <button
                    // style={{
                    //   background: "none",
                    //   border: "none",
                    //   cursor: "pointer",
                    //   textDecoration: "underline",
                    //   color: "blue",
                    // }}
                    >
                      <span>
                        <img
                          src={`${BASEURL}/images/indoor_camera.svg`}
                          width="23"
                          height="23"
                          alt="indoor camera icon"
                        />
                      </span>{" "}
                      {propertyData.website_sub_menu_price && propertyData.website_sub_menu_price}
                    </button>
                  </li>
                  {data[0] && (
                    <li>
                      <a href={`tel:${data[0]}`}>
                        <span>
                          <img
                            src={`${BASEURL}/images/call.svg`}
                            width="23"
                            height="23"
                            alt="call icon"
                          />
                        </span>{" "}
                        Call
                      </a>
                    </li>
                  )}
                  {data[1] && (
                    <li>
                      <a href={`mailto:${data[1]}`}>
                        <span>
                          <img
                            src={`${BASEURL}/images/email_sign.svg`}
                            width="23"
                            height="23"
                            alt="email sign icon"
                          />
                        </span>{" "}
                        Email
                      </a>
                    </li>
                  )}
                </ul>
              </div>
            </div>
            <div className="col-md-6 col-sm-6 col-12">
              <div className="portfolio-details-right">
                <img
                  src={propertyData.sub_menu_file}
                  width="489"
                  height="400"
                  alt="properties img"
                />
              </div>
            </div>
          </div>
        ) : (
          "<div>Loading...</div>"
        )}
      </div>
    </div>
  );
};
